module.exports = __webpack_public_path__ + "img/lottery-back.513bee63.jpg";